// extracted by mini-css-extract-plugin
export default {"top-bar":"top-bar--2d3qa","top-bar__collection-info":"top-bar__collection-info--3vem4","top-bar__change-collection":"top-bar__change-collection--1klU6","top-bar__logo":"top-bar__logo--OCSPJ","top-bar__collection-name":"top-bar__collection-name--3CkPO","top-bar__nav":"top-bar__nav--3ukPN","st-navigation":"st-navigation--1Sy8L","st-navigation__link":"st-navigation__link--mq-OP"};
    if(module.hot) {
      // 1747648138096
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  